enum StepType {
  General = "General",
  Email = "Email",
  Document = "Document",
}

export { StepType };
